import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { listRefreshablePortalSessions } from "@/core/auth/listPortalSessions";
import { useAppStore } from "@/core/store/useAppStore";
import { LoginPage, LoginPending } from "../components/LoginPage";
import { resolvePortalStart } from "./portalStart";
import { PortalWorkspaceChooser } from "./PortalWorkspaceChooser";

/**
 * Manifest start_url target: route to the stored workspace by role, show
 * the workspace chooser for multi-session devices, or fall to login.
 * Presence is refresh-capable (TD-016) — expired access tokens with a
 * stored refresh token still count; the target surface refreshes them.
 */
export const PortalStartRoute: React.FC = () => {
  const navigate = useNavigate();
  const hasHydrated = useAppStore((state) => state._hasHydrated);
  // An admin session is a user with a refresh token (spec 2026-10-15): one
  // whose access token expired still opens the app, the guard refreshes it.
  const hasAdminSession = useAppStore((state) => !!state.user?.refreshToken);
  const sessions = useMemo(() => listRefreshablePortalSessions(), []);
  const target = hasHydrated ? resolvePortalStart(sessions, hasAdminSession) : undefined;

  useEffect(() => {
    if (typeof target === "string") {
      navigate(target, { replace: true });
    }
  }, [navigate, target]);

  if (target === null) {
    return <PortalWorkspaceChooser sessions={sessions} />;
  }

  return (
    <LoginPage>
      <LoginPending label="Apertura in corso..." />
    </LoginPage>
  );
};
